module.exports = __webpack_public_path__ + "static/19-dcec8027fc37e4d554883f188ca5152a.jpg";